
<div
  #toastElement
  class="toast align-items-center fade toast-width mt-2 border-0"
  [ngClass]="type"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <!-- <div class="toast-header">
    <strong class="me-auto">{{ title }}</strong>
    <button type="button" class="btn-close" aria-label="Close" (click)="hide()"></button>
  </div> -->
  <div class="d-flex">
  <div class="toast-body">{{ message }}</div>
  <button type="button" class="btn-close btn-close-white me-2 m-auto" aria-label="Close" (click)="hide()"></button>
</div>
</div>


